import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

// Backend integration point: Replace with your Supabase project URL and anon key
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

export type UserRole = 'customer' | 'seller' | 'admin';

export interface AppUser {
  id: string;
  phone: string;
  role: UserRole;
  display_name: string;
  avatar_url?: string;
  balance: number;
  earnings: number;
  created_at: string;
}

export interface Post {
  id: string;
  seller_id: string;
  title: string;
  description: string;
  hourly_rate: number;
  age?: number;
  height?: number;
  weight?: number;
  category: string;
  images: string[];
  status: 'active' | 'paused' | 'deleted';
  created_at: string;
  seller?: AppUser;
}

export interface Rental {
  id: string;
  post_id: string;
  customer_id: string;
  seller_id: string;
  status: 'pending' | 'confirmed' | 'active' | 'completed' | 'cancelled' | 'refunded';
  hourly_rate: number;
  amount_paid: number;
  total_amount: number;
  timer_started_at?: string;
  timer_stopped_at?: string;
  customer_start_confirmed: boolean;
  seller_start_confirmed: boolean;
  customer_stop_confirmed: boolean;
  seller_stop_confirmed: boolean;
  duration_minutes: number;
  created_at: string;
  post?: Post;
  customer?: AppUser;
  seller?: AppUser;
}

export interface Message {
  id: string;
  rental_id: string;
  sender_id: string;
  content: string;
  created_at: string;
  sender?: AppUser;
}

export interface Transaction {
  id: string;
  rental_id?: string;
  user_id: string;
  type: 'debit' | 'credit' | 'refund' | 'earning';
  amount: number;
  description: string;
  created_at: string;
}